import echarts from "@/util/vo-echarts";
import device from "@/api/device";
//import * as echarts from "echarts";
//import * as echarts from 'echarts/core';

import { createLineChartLabel } from "@/util/utils";

const graphic = require("echarts/lib/util/graphic");
import store from "@/store";

const voltageData = {
  color: [store.state.theme.curveColor],
  xAxis: {
    show: false,
    type: "category",
    boundaryGap: false,
    data: ["1", "2", "3", "4", "5", "6", "7", "8"]
  },
  yAxis: {
    show: false,
    type: "value"
  },
  grid: { bottom: 4, left: 22, right: 22, top: 22 },
  series: [
    {
      data: [1.3, 1.7, 3.3, 4, 2.0, 2.9, 3.6, 2],
      type: "line",
      smooth: true,
      symbol: "circle",
      symbolSize: 8,
      label: {
        show: true,
        position: "top",
        formatter: function(a) {
          // console.log(`c = ${c}`);
          return `${a.value.toFixed(2)}W`;
        },
        color: store.state.theme.curveColor,
        fontSize: 10,
        distance: 4
      },
      areaStyle: {
        color: graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: store.state.theme.curveLineColor[0] //c0dee2
          },
          {
            offset: 1,
            color: store.state.theme.curveLineColor[1] //f6fafa
          }
        ])
      }
    }
  ]
};

export function chartConfig() {
  return {
    color: [store.state.theme.curveColor],
    xAxis: {
      show: false,
      type: "category",
      boundaryGap: false,
      data: ["1", "2", "3", "4", "5", "6", "7", "8"]
    },
    yAxis: {
      show: false,
      type: "value"
    },
    grid: { bottom: 4, left: 22, right: 22, top: 22 },
    series: [
      {
        data: [2, 2, 2, 2, 2, 2, 2, 2],
        type: "line",
        smooth: true,
        symbol: "circle",
        symbolSize: 8,
        label: {
          show: true,
          position: "top",
          formatter: function(a) {
            // console.log(`c = ${c}`);
            let value = a.value;
            return `${a.value.toFixed(1)}W`;
          },
          color: store.state.theme.curveColor,
          fontSize: 10,
          distance: 4
        },
        areaStyle: {
          color: new graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: store.state.theme.curveLineColor[0] //c0dee2
            },
            {
              offset: 1,
              color: store.state.theme.curveLineColor[1] //f6fafa
            }
          ])
        }
      }
    ]
  };
}

export function d019ChartConfig(deviceType, currentLevel,showLabel=true) {
  const defaultChartConfig = chartConfigBlue(showLabel);
  if (deviceType === "D019") {
    switch (currentLevel) {
      case 1:
        const color = "rgba(255, 140, 0, 1)";
        const curveColorLinearGradient = ["rgba(255, 140, 0, 1)", "rgba(255, 140, 0, 0.2)"];
        defaultChartConfig.color[0] = color;
        defaultChartConfig.series[0].label.color = color;
        defaultChartConfig.series[0].areaStyle.color = graphic.LinearGradient(
          0,
          0,
          0,
          1,
          [
            {
              offset: 0,
              color: curveColorLinearGradient[0] //c0dee2
            },
            {
              offset: 1,
              color: curveColorLinearGradient[1] //f6fafa
            }
          ]
        );
        break;
      default:
        break;
    }
  }
  return defaultChartConfig;
}

export function chartConfigBlue(showLabel=true) {
  return {
    color: [store.state.theme.curveColor],
    xAxis: {
      show: false,
      type: "category",
      boundaryGap: false,
      data: ["1", "2", "3", "4", "5", "6", "7", "8"]
    },
    yAxis: {
      show: false,
      type: "value"
    },
    grid: showLabel ? { bottom: 4, left: 22, right: 22, top: 22 }:{bottom: 10, left: 4, right: 4, top: 0},
    series: [
      {
        data: [2, 2, 2, 2, 2, 2, 2, 2],
        type: "line",
        smooth: true,
        symbol: "circle",
        symbolSize: 8,
        label: {
          show: showLabel,
          position: "top",
          formatter: function(a) {
            // console.log(`c = ${c}`);
            let value = a.value;
            return `${a.value.toFixed(1)}W`;
          },
          color: store.state.theme.curveColor,
          fontSize: 10,
          distance: 4
        },
        areaStyle: {
          color: new graphic.LinearGradient(0, 1, 0, 0, [
            {
              offset: 1,
              color: "rgba(0, 60, 255, 1)" //c0dee2
            },
            {
              offset: 0.75,
              color: "rgba(108, 158, 255, 0.75)" //c0dee2
            },
            {
              offset: 0,
              color: "rgba(255, 255, 255, 0)" //c0dee2
            }
          ])
        }
      }
    ]
  };
}

export function lineChartHomeBlue(voltages, showLabel,grid = {
  top: "20%", // 设置顶部边距为 20%
  bottom: "20%", // 设置底部边距为 20%
  right: "16px",
  left: "32px"
}) {
  return {
    grid,
    xAxis: {
      min: 1,
      max: 8,
      interval: 1,
      splitLine: {
        show: false
      },
      type: "value",
      axisTick: {
        alignWithLabel: true // true：标签位于刻度线正下方；false：标签位于2个刻度线中间
      },
      axisLabel: {
        formatter: (item) => {
          return `${item}S`;
        },

        margin: 10 // 将刻度标签向外凸出 10px
      },
      axisLine: {
        symbolOffset: [10, 10]
      }
    },
    yAxis: {
      min: 0,
      max: 10,
      interval: 2,
      type: "value",
      axisLabel: {
        inside: false,
        margin: 20
      },
      axisLine: { // 隐藏 y 轴线
        show: false
      },
      axisTick: {
        show: false
      }
    },
    series: [
      {
        id: "a",
        z: 10,
        type: "line",
        smooth: true,
        data: voltages.map((item) => {
          return createLineChartLabel(item[0], item[1], false,showLabel);
        }),

        label: {
          show: showLabel,
          position: "top",
          formatter: function(a) {
            let value = a.value;
            if (!value) {
              return ``;
            }
            return `${a.value.toFixed(1)}W`;
          },
          color: store.state.theme.curveColor,
          fontSize: 10,
          distance: 4
        },
        symbolSize: 14,
        symbol: "circle",

        markLine: {
          silent: true, // 设置为 true，点击时不触发事件
          data: [
            // {type: 'x', xAxis: 3}, // 标记 x 轴的横线
            // {type: 'y', yAxis: 2}  // 标记 y 轴的竖线
          ],

          lineStyle: {
            color: "#333", // 设置线的颜色
            type: "solid" // 设置线的类型为实线
          },
          label: {
            show: false // 隐藏标记线的文字标签
          },
          symbol: ["none", "none"] // 设置标记线的箭头为空
        },
        areaStyle: {
          color: new graphic.LinearGradient(0, 1, 0, 0, [
            {
              offset: 1,
              color: "rgba(0, 60, 255, 1)" //c0dee2
            },
            {
              offset: 0.75,
              color: "rgba(108, 158, 255, 0.75)" //c0dee2
            },
            {
              offset: 0,
              color: "rgba(255, 255, 255, 0)" //c0dee2
            }
          ])
        }
      }
    ]
  };
}

export { voltageData };
